<template>
    <div class="notification-container">
        <div class="notification">
            <div class="notification__header clearfix">
                <button class="btn-close" @click="close"></button>
            </div>
            <div class="notification__content" @click="notificationClicked">Aujourd'hui, vous avez {{eventsNbr}} actions à mener</div>
            <div class="notification__footer"></div>
        </div>
        <div class="notification-bg" @click="close"></div>
    </div>
</template>

<script>
    import {eventBus} from '../../main';

    export default {
        props: [
                'eventsNbr'
        ],
        methods: {
            close() {
                eventBus.$emit('notification:close');
            },
            notificationClicked() {
                eventBus.$emit('notification:clicked');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Notification.vue?7b333948